import React from 'react';
import { TriggerNodeData, TRIGGER_EVENT_OPTIONS, CHANNEL_OPTIONS, REPLY_TRIGGER_HINTS } from '../types';
import { useOrgTicketTypes } from '../hooks/useOrgData';
import { ThemedSelect } from '@components/common/ThemedSelect';

interface Props {
  data: TriggerNodeData;
  onChange: (updated: Partial<TriggerNodeData>) => void;
}

export function TriggerConfig({ data, onChange }: Props) {
  const { ticketTypes, loading } = useOrgTicketTypes();

  return (
    <div className="space-y-4">
      <div>
        <label className="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-200">When this event happens</label>
        <ThemedSelect
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          value={data.eventType}
          onChange={(e) => onChange({ eventType: e.target.value })}
        >
          {TRIGGER_EVENT_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </ThemedSelect>
        {REPLY_TRIGGER_HINTS[data.eventType] && (
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{REPLY_TRIGGER_HINTS[data.eventType]}</p>
        )}
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-200">From channel</label>
        <ThemedSelect
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          value={data.channel || 'any'}
          onChange={(e) => onChange({ channel: e.target.value })}
        >
          {CHANNEL_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </ThemedSelect>
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-200">
          Ticket type filter <span className="text-gray-400 dark:text-gray-500">(optional — leave blank for all)</span>
        </label>
        <ThemedSelect
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          value={data.ticketTypeId || ''}
          onChange={(e) => {
            const selected = ticketTypes.find((t) => t.id === e.target.value);
            onChange({
              ticketTypeId: e.target.value || undefined,
              ticketTypeName: selected?.name,
            });
          }}
        >
          <option value="">Any ticket type</option>
          {loading ? (
            <option disabled>Loading…</option>
          ) : (
            ticketTypes.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))
          )}
        </ThemedSelect>
      </div>
    </div>
  );
}
